import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/data/site";

const steps = [
  { n: "01", title: "Prima dell’arrivo", text: "Informazioni chiare, conferma della prenotazione e indicazioni per il check-in." },
  { n: "02", title: "Durante il soggiorno", text: "Assistenza disponibile per necessità, informazioni e suggerimenti." },
  { n: "03", title: "Dopo la partenza", text: "Supporto conclusivo e attenzione al feedback dell’ospite." },
];

export default function Hospitality() {
  return (
    <section className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-brand-gold mb-4">La nostra ospitalità</p>
          <h2 className="font-heading font-light text-4xl md:text-5xl text-brand-black leading-tight">Ospitalità curata, dall’arrivo alla partenza.</h2>
          <div className="mt-6 space-y-4 text-brand-brown leading-relaxed">
            <p>Ogni struttura mantiene il proprio carattere, ma tutte condividono lo stesso metodo di gestione: informazioni chiare, assistenza tempestiva, ambienti preparati con attenzione e un rapporto diretto con l’ospite.</p>
            <p>Martelli Rentals coordina la comunicazione, le prenotazioni e l’esperienza di soggiorno, con l’obiettivo di rendere ogni arrivo semplice e ogni permanenza piacevole.</p>
          </div>
          <div className="mt-10 space-y-6">
            {steps.map((s) => (
              <div key={s.n} className="flex gap-5">
                <span className="font-heading text-3xl text-brand-gold/70 leading-none">{s.n}</span>
                <div>
                  <h3 className="font-medium text-brand-black">{s.title}</h3>
                  <p className="text-sm text-brand-brown mt-1">{s.text}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={100}>
          <img src="/images/properties/la-terra-di-gaia/terra-di-gaia-colazione-giardino-monte-velino.webp" alt="Colazione preparata alla Terra di Gaia, in giardino con vista sul Monte Velino" loading="lazy" className="w-full h-[420px] md:h-[600px] object-cover rounded-2xl" />
        </Reveal>
      </div>
    </section>
  );
}
